import { APIClient } from '@frontend/api-utils';

export class WorkflowActionClient extends APIClient {
    public static readonly endpoint = '/workflow-api/v1';

    public static async fetchWorkflowActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/workflow-actions`);
        return await this.handleResponse(response);
    }
}
